import { CSVEntityItem } from './CSVEntityItem'

export const ConcreteMixDesign = new CSVEntityItem({
  id: 'fbd89fd1-094d-43f0-8855-938cf7c46a07',
  queryParameter: 'concrete-mix-design',
  headers: [
    'Global ID',
    'Status',
    'Admixtures',
    'Aggregates',
    'Air Range',
    'Class',
    'Use',
    'Expiration Date',
    'Supplier',
    'Max Agg Size',
    'Mix ID',
    'Slump Range',
    'Submittal ID',
    'W/C Ratio',
    'customFields',
  ],
  classType: 'ConcreteMixDesign',
  classTypeName: 'Concrete Mix Design',
  filtered: true,
})
export const DesignSubmittal = new CSVEntityItem({
  id: '1162bab1-3fa4-464f-904d-fee07dce3f65',
  queryParameter: 'design-submittal',
  headers: [
    'Creation Date',
    'Status',
    'External Links',
    'Package Number',
    'Package Name',
    'Type',
    'Disciplines',
    'Actions',
    'Submitted By',
    'Submitted Organizations',
    'Submitted Date',
    'Requested Action Date',
    'Contract Due Date',
    'Disposition',
    'Disposition Date',
    'Disposition By',
    'Pay Items',
    'Comments',
    'ID',
  ],
  classType: 'DesignSubmittal',
  classTypeName: 'Design Submittal',
  filtered: true,
})
export const ConstructionAdminSubmittal = new CSVEntityItem({
  id: 'd9fe5b1e-772f-4896-866f-fb33607024fe',
  queryParameter: 'construction-admin-submittal',
  headers: [
    'Status',
    'Routing Groups',
    'External Links',
    'Package Number',
    'Package Name',
    'Type',
    'Subtype',
    'Quantity',
    'Units',
    'User',
    'Created Date',
    'Requested Review Date',
    'Contract Date',
    'Disposition',
    'Disposition Date',
    'Pay Items',
    'Comments',
    'customFields',
  ],
  classType: 'ConstructionAdminSubmittal',
  classTypeName: 'Construction & Admin Submittal',
  filtered: true,
})
export const FieldDesignChanges = new CSVEntityItem({
  id: '62b488ad-5ca3-42d3-81fc-ed27fff7caa4',
  queryParameter: 'field-design-changes',
  headers: [
    'Number',
    ' Status',
    'Concurrence Level Name',
    'Concurrence Level Description',
    'Location',
    'Drawings Affected',
    'Issue',
    'Resolution',
    'Submitted By',
    'Date Submitted',
    'Comments',
    'customFields',
    'Requested Approval Date',
    'Concurrence By',
    'Date Concurred',
    'Approval By',
    'Date Approved',
    'Created Date',
    'Deleted User',
    'Deleted Date',
    'Project ID',
    'Pay Items',
  ],
  classType: 'FieldDesignChange',
  classTypeName: 'Field Design Change',
})
export const IdentifiedFieldIssue = new CSVEntityItem({
  id: '9d33bcf3-8d9d-4cd6-93d0-42be5a66cca1',
  queryParameter: 'identified-field-issue',
  headers: [
    'Status',
    'Report ID',
    'Report Type',
    'Report Review Status',
    'Report Date',
    'Suggested Issue Types',
    'Issue Description',
    'Reviewed By',
    'Review Notes',
    'Issue Review Date',
    'Comments',
    'customFields',
  ],
  classType: 'IdentifiedFieldIssue',
  classTypeName: 'Identified Field Issue',
})
export const Issue = new CSVEntityItem({
  id: 'b992aea1-5ee3-438a-8de7-2287529a575e',
  queryParameter: 'issue',
  headers: [
    'Status',
    'Item Number',
    'Identified Field Issue',
    'Reports',
    'Types',
    'Description',
    'Submitted By',
    'Submitted Date',
    'Response',
    'Response By',
    'Response Date',
    'Disposition',
    'Disposition Notes',
    'Disposition By',
    'Disposition Date',
    'Closure Notes',
    'Closed By',
    'Closed Date',
    'Pay Items',
    'Comments',
    'customFields',
    'Deleted By',
    'Deleted Date',
  ],
  classType: 'Issue',
  classTypeName: 'Issue',
})
export const RequestForInformation = new CSVEntityItem({
  id: '70351cb5-8af5-4487-b027-9727de2e06e0',
  queryParameter: 'request-for-information',
  headers: [
    'Number',
    'Status',
    'Description',
    'Organization',
    'Requested Response Date',
    'Response Disciplines',
    'Submitted By',
    'Date Submitted',
    'Closed Date',
    'Comments',
    'customFields',
    'Created Date',
    'Deleted User',
    'Deleted Date',
    'Project ID',
  ],
  classType: 'RequestForInformation',
  classTypeName: 'Request For Information',
})
export const AsphaltMixDesign = new CSVEntityItem({
  id: 'a681b970-d4e8-4ef4-a70d-56106bd5a8f1',
  queryParameter: 'asphalt-mix-design',
  headers: [
    'Status',
    'Mix ID',
    'Supplier',
    'Nominal Size',
    'Binder Grade',
    'Design Builder Content',
    'VMA',
    'Theoretical Max Specific Gravity',
    'Targets',
    'Specific Gravity of Aggregate',
    'Material Source',
    'Expiration Date',
    'Max Aggregate Size',
    'customFields',
  ],
  classType: 'AsphaltMixDesign',
  classTypeName: 'Asphalt Mix Design',
})
export const PayItemNoGeometry = new CSVEntityItem({
  id: 'cfec47a8-2d1b-4cde-bffd-8aad4a71fd82',
  queryParameter: 'pay-item-no-geometry',
  headers: [
    'createdDate',
    'createdUser',
    'deleted',
    'description',
    'globalId',
    'label',
    'lastEditedDate',
    'lastEditedUser',
    'materialGuid',
    'payItemId',
    'projectId',
    'status',
  ],
  importColumns: ['globalId', 'payItemId', 'description', 'deleted'],
  upsertKeys: ['payItemId', 'globalId'],
  classType: 'PayItemNoGeometry',
  classTypeName: 'Pay Item',
})
